'use client';

import { useCallback } from 'react';

import { useBrowsing } from 'hooks/use-browsing';

import { PUBLIC_LOGIN_URL_ENV } from 'tools/environments';

type UseRedirectProps = {
	path?: string;
	code?: number;
};

export const useRedirect = () => {
	const { asPath, basePath, push } = useBrowsing();

	// Memoised so callers can list `redirect` in effect dependency arrays
	// without the effect re-running on every render.
	return useCallback(
		({ path, code }: UseRedirectProps) => {
			if (!path && !code) return;

			if (path && !code) push(path);

			switch (code) {
				case 401: {
					const origin =
						typeof window !== 'undefined'
							? window.location.origin
							: '';
					window.location.replace(
						`${PUBLIC_LOGIN_URL_ENV}?returnUrl=${origin}${basePath}${asPath}`
					);
					break;
				}
				case 404:
				case 400:
					push(path || '/404');
					break;
				case 500:
					push(path || '/500');
					break;
				default:
					break;
			}
		},
		[asPath, basePath, push]
	);
};

export default useRedirect;
